(function() {
  window.adConfigs = window.adConfigs || {};

  const flavours = ['Caramel', 'Peanut Butter', 'Pistachio', 'Raspberry', 'Hazelnut', 'Malt Cornflakes'];

  function buildFlavourList(leadFlavour) {
    const reordered = [leadFlavour, ...flavours.filter(f => f !== leadFlavour)];
    return 'Six bars: ' + reordered.join(' · ');
  }

  function buildFlavourChips(leadFlavour) {
    const reordered = [leadFlavour, ...flavours.filter(f => f !== leadFlavour)];
    const chips = reordered.map((f, i) => {
      const isLast = i === reordered.length - 1;
      const chip = `<span class="bb-flavour-chip">${f}</span>`;
      const sep = isLast ? '' : ' <span class="bb-sep">·</span> ';
      return isLast ? `<nobr>${chip} <a href="/pages/build-your-box" class="bb-build-link">– Customise →</a></nobr>` : `${chip}${sep}`;
    }).join('');
    return `<span style="color: #5b4637;">Six handmade filled chocolate bars</span><br>${chips}`;
  }

  const giftings = {
    'classic':          'A gift that always lands - just pick their favourites',
    'thinking-of-you':  'A gift that always lands - just pick their favourites',
    'well-done':        'A gift that always lands - just pick their favourites',
    'thank-you':        'A gift that always lands - just pick their favourites',
    'happy-birthday':   'A gift that always lands - just pick their favourites',
  };

  const giftingImages = {
    'classic': {
      'caramel':      null,
      'peanutbutter': 'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/Gifting-ad-classic.png?v=1776365620',
      'pistachio':    null,
      'raspberry':    null,
      'pretzel':      null,
      'slideopenupwardssunshine':       'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/Barney_goff_Change_the_dimensions_61401834-dbb2-4dbc-8fe8-c3ca812f95ff.png?v=1777548947',
      'slideopen': 'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/Slide_open_gifting_ad.png?v=1776687876',
      'slideopenwithpeople': 'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/Gifting_Handheld_sleeve_lifting_pdp.png?v=1777549652',
    },
    'thinking-of-you': {
      'caramel':      null,
      'peanutbutter': null,
      'pistachio':    null,
      'raspberry':    null,
      'pretzel':      null,
      'smaltz':       null,
    },
    'well-done': {
      'caramel':      null,
      'peanutbutter': null,
      'pistachio':    null,
      'raspberry':    null,
      'pretzel':      null,
      'smaltz':       null,
    },
    'thank-you': {
      'caramel':      null,
      'peanutbutter': null,
      'pistachio':    null,
      'raspberry':    null,
      'pretzel':      null,
      'smaltz':       null,
    },
    'happy-birthday': {
      'caramel':      null,
      'peanutbutter': null,
      'pistachio':    null,
      'raspberry':    null,
      'pretzel':      null,
      'smaltz':       null,
    },
  };

  const flavourKeys = {
    'caramel':      'Caramel',
    'peanutbutter': 'Peanut Butter',
    'pistachio':    'Pistachio',
    'raspberry':    'Raspberry',
    'pretzel':      'Hazelnut',
    'smaltz':       'Malt Cornflakes',
    'slideopen': 'Caramel',
    'slideopenupwardssunshine': 'Caramel',
    'slideopenwithpeople': 'Caramel',
  };

  Object.entries(giftings).forEach(([gifting, subline1]) => {
    Object.entries(flavourKeys).forEach(([flavourKey, flavourLabel]) => {
      const key = `gifting-${gifting}-${flavourKey}`;
      const pdpImage = giftingImages[gifting][flavourKey];
      const flavourList = buildFlavourList(flavourLabel);
      const flavourChips = buildFlavourChips(flavourLabel);

      // Version A — box in cart (no cartImage)
      window.adConfigs[key] = {
        subline1,
        subline2:  flavourChips,
        cartSub:   flavourList,
        image:     pdpImage,
        cartImage: null,
      };

      // Version B — PDP image in cart
      window.adConfigs[`${key}-pdpcart`] = {
        subline1,
        subline2:  flavourChips,
        cartSub:   flavourList,
        image:     pdpImage,
        cartImage: pdpImage,
      };
    });
  });

})();